export default __webpack_public_path__ + "static/latitiude-scam-alert-11-9355126b059349eb246bda26390eb747.png";